import { render, staticRenderFns } from "./publicImport.vue?vue&type=template&id=4e24689a&scoped=true"
import script from "./publicImport.vue?vue&type=script&lang=js"
export * from "./publicImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24689a",
  null
  
)

export default component.exports